import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import HtmlImage from './icon-html-image.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <HtmlImage {...validProps} />;
}
SvgComponent.iconName = 'html-image';

/**
 * @deprecated This is a legacy icon
 */
export const HtmlImageIcon = svgIconWrapper(SvgComponent);
